import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function C({ langKey }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');

    const cards: any = [
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/3_1.jpg'),
            text: t('secC_text1'),
        },
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/3_2.jpg'),
            text: t('secC_text2'),
        },
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/3_3.jpg'),
            text: t('secC_text3'),
        },
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/3_4.jpg'),
            text: t('secC_text4'),
        },
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/3_5.jpg'),
            text: t('secC_text5'),
        },
    ];

    return (
        <div className={`power-ocean-collection-C ${css['power-ocean-collection-C']}`}>
            <div className="text-box">
                <p className="title">{t('secC_title')}</p>
            </div>
            <div className="card-box">
                {cards?.map((card: any, k: number) => (
                    <div key={k} className={`card card${k + 1}`}>
                        <NextImage src={card?.img} alt={card?.text} aria-label={card?.text} />
                        <p className="text">{card?.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
